import { ActivityEntityName } from './activity.entity.name';
import { Entity, EntityLink } from '../entity';
import { Label } from './label';

export enum FlagStatus {
  Open = 'Open',
  Closed = 'Closed',
}

export interface EntityFlag extends Entity {
  category: Label;
  entity: ActivityEntityName;
  entityId: string;
  status: FlagStatus;
  message: string;
  outcome?: string;
  source: string;
  links?: EntityLink[];
  createdAt?: Date;
  createdBy?: Entity;
  closedAt?: Date;
  closedBy?: Entity;
}

export interface FlagCreateRequest {
  category: Label;
  entity: ActivityEntityName;
  entityId: string;
  message: string;
  source: string;
  links?: EntityLink[];
}

export interface FlagCloseRequest {
  flagId: string;
  outcome?: string;
}

export enum FlagCqrsActions {
  Create = 'FlagCreateCommand',
  Close = 'FlagCloseCommand',
  GetByEntity = 'GetFlagsByEntityQuery',
}
